
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'h1fbdfea3ad6d664e': html`This is brought by the
                    <a href="${0}">Folksonomy Engine project</a>. Don't
                    hesitate to participate or give feedback`,
'h5d824b4954e56ea5': html`Scan your <span class="everyday">everyday</span> <span class="foods">foods</span>`,
'h6bdd1b427aa985a4': html`このツールを使うと、材料リストを修正できます。
                の材料リストを追加、削除、編集できます。
                <br>
                この文字 <span class="highlight">␣</span> はスペースを表します。
                <br>
                この文字 <span class="highlight">↩︎</span> は改行を表します。 `,
'hb28f1f2ec1744ee9': html`These properties are created and filed by users for any kind of usages. Feel
                    free to add your own. The properties and values you create
                    <strong>must be factual</strong>. You can dive into
                    <a href="${0}">the list of properties already used by the community</a>
                    or explore the
                    <a href="${1}">properties' documentation and its search engine</a>.`,
's000a5b76bd3a01c2': `プロパティを読み込んでいます...`,
's000d98595e959c1e': `Google Play で利用できます`,
's013bdc8cf0d3583d': `材料費の援助`,
's01d2865e3e1d5501': `Thank you for your assistance!`,
's02ce7a2e7c1b020b': `作物の検証`,
's03e9c8114521b998': `材料を編集します`,
's05ec315d9308091a': `バーコードコーナーアイコン`,
's061eb5af92512c85': `保存しました！もう一つ手伝ってもらえますか？`,
's06847c221c4c0bc1': `[ユースケースを説明する] プロパティを作成したいと思います...`,
's06f6c6f99db6b552': `オリジナル`,
's081e2ad82db71e1d': `グループ化された値`,
's09205907b5b56cda': `いいえ`,
's0b4235aae602a950': `専用ドキュメント`,
's0bb2d48532acc455': `CSVをダウンロード`,
's0d5b7fee0311db68': `財産`,
's0fb218abc2e157ed': `画像を無効にする`,
's100c4928cc74642a': `公衆衛生研究の進歩を支援する。`,
's10db5498186c083b': `切り取りをキャンセル`,
's11a18a69b30b65ed': `原材料リストの誤りを修正するためにご協力ください`,
's1205d5f6fccf8e69': `不動産価値`,
's15d64a0a6715285a': `新しいキー`,
's166bd56d19670a72': `Zoom`,
's19059bf0c4f7c162': `選択領域`,
's1a52515ec8ddade8': `製品バーコード`,
's1c5031113de500ce': `keeping our database open &amp; available to all,`,
's1dc4daf989c71284': `栄養情報の修正にご協力ください`,
's1e00019dc454872d': `property-name 属性を使用してプロパティ名を指定してください。`,
's1e49126af0935a5b': `このプロパティを使用している製品のリスト`,
's21e73088de6f26f3': `App Store で利用できます`,
's255857544a9d5ec0': `Reset`,
's25e94495991e95ba': `Thanks for your help! Can you assist with another question?`,
's2ceb11be2290bb1b': `取消`,
's2db7b654c0a9bde0': `物件を文書化する`,
's300b3a6ee4e1252d': str`不一致 ${0}%`,
's33f786bb6b4f0cf4': `作物の結果`,
's33f85f24c0f5f008': `保存`,
's34be4af4e8fec4ae': `まずはコミュニティに聞いてみよう`,
's36d86adc823cbfa6': `新しいプロパティを作成する前に、コミュニティと話し合ってください。`,
's3781d25aa51a736c': `Folksonomy Engine ドキュメント`,
's383ae4449428b61e': `切り取りをリセット`,
's39bcf88721a1e8ee': `選択をリセット`,
's39e14e14300694c7': `ドキュメントとガイドライン`,
's3b430cfa5c1fe7f4': str`${0}のドキュメント`,
's3f4e4b52f230a892': `画像キャンバス`,
's417b90913e05bc17': `プレビュー`,
's41f7dca46d3f1b4a': `値：`,
's422bba9636ce2489': `中央の画像`,
's42dd66b2441566fd': `中央アイコン`,
's43df2e8395f6834e': str`Please give to our ${0} Fundraiser`,
's453188ea728f64da': `栄養成分を追加`,
's453ab0dbb9b5c777': `右にサイズを変更`,
's475b08749d0706ed': `世界中の何百万人もの消費者に、彼らが何を食べているかを伝えるお手伝いをしてください`,
's49730f3d5751a433': `読み込み中…`,
's4bbc7472834a9686': `Your browser does not support barcode scanning.`,
's4d42cc7e00076a3b': `商品数`,
's4df2f533c0c1e7d0': `画像コントロール`,
's4e94adf723979402': `Open Food Facts needs your help with this product.`,
's4f4886341969d552': `選択範囲を移動`,
's4f751fb9b3ed766c': `新しいプロパティの作成`,
's547c12ae169d00bc': `Available on F-Droid`,
's5560fb119e40923d': `プロパティ名を入力してください...`,
's55d7249883a98ca1': `Open Food Facts wikiでこのプロパティについて`,
's565867d84c04aea2': `フィルターのプロパティ...`,
's5666afe5cd0166de': `確認する前にエラーを修正するかテキストを変更してください`,
's57472465a23b41db': `Values`,
's58e1eeea7a60ae51': `製品を読み込んでいます...`,
's59df20feee978e5b': `Error: Invalid value.`,
's5c92c0051d44b6de': `栄養情報の修正にご協力ください。`,
's5dd6f12783fca34f': `材料リストを編集する`,
's5e8250fb85d64c23': `閉じる`,
's5ed03bb1f3a15949': `画像`,
's6306a31415aea913': `私は支持する`,
's6498dfe4855bb3a7': `unit`,
's64ef2a6c2dd1d3d1': `編集`,
's66413c24dcf680e2': `スキップ`,
's67ae6594857a4d57': `ご協力ありがとうございました！`,
's6cee7cad81dfedd1': `切り抜かれた画像`,
's6d7b6cdedaadfb6e': `一つ一つの寄付が大切です！世界の食品の透明性向上に貢献できるよう、皆様のご支援をお願いいたします。`,
's7124dde792a8faa2': `Android APK`,
's718dea04853f80ae': str`良い一致 ${0}%`,
's71a5c9f4b68ef4d4': `カウント`,
's74cb3d66f6a668e1': `ドキュメント`,
's787dd11bed0dc88a': `左にサイズを変更`,
's7ce4fd9430e80cea': `値`,
's801a05fa8e881f37': `プロパティの作成とガイドラインの詳細については、以下を参照してください。`,
's8038273de2cf8b73': `切り取る領域を選択してください。`,
's839cc2908a5387f2': `バーコードをフィルター...`,
's86197dcf3e96af64': `既存の物件を閲覧・検索する`,
's8a63be30a129a59c': `下部のサイズを変更`,
's8a8bfd67f2dd2810': `Download the OFF app with this QR code`,
's8af61807443f32a4': `Actions`,
's8b33c244759d7bd4': `右上のサイズを変更`,
's8db84aa4bc949af2': `新しいプロパティを文書化する`,
's8f839a03997a16d7': `製品を見る`,
's901ae1e236ac45d3': `削除をキャンセル`,
's907f7a97c6b29425': `データモデルは変更される可能性があるので注意してください。自己責任でご利用ください。`,
's95d23d03f9147581': `Unzoom`,
's976dfd19ef58a1e1': `Click to scan a barcode and find out its details (health, preferences, etc.)`,
's98ff35f2a00dc60d': `材料 ：`,
's9a7f60fce090ecaf': `プロパティの読み込みに失敗しました。しばらくしてからもう一度お試しください。`,
's9b87abd68fb9df45': `見つかりませんか？新しいキーを作成してください {value}`,
's9c0f52425fd2f07e': `一致しない場合があります`,
's9fc41f789c63b40d': `製品`,
'sa1fa766e0d5634d7': `スコアはありません`,
'sa548778b24054030': `Folksonomy Engineプロジェクトから提供されたすべてのプロパティをご覧ください。これらのプロパティは、Open Food Factsデータベース内の製品に関する追加のメタデータと洞察を提供します。`,
'sa63907958bd0ec4b': `左上のサイズを変更`,
'sa95b4224f685a36a': `モーダルを閉じる`,
'sab56a1d439576fd6': `提案アイコン`,
'sac47ea2901d04c15': `左下のサイズを変更`,
'sb125227d436c2925': `既存のプロパティ データベースでプロパティ コンセプトを検索します。`,
'sb125568d43642e6f': `製品に関する質問に答えます。`,
'sb1c538e038f9b214': str`非常に良い一致 ${0}%`,
'sb28639570ff3b852': `すべてのプロパティのリスト`,
'sb3bdd638a58d30f4': `熱心な市民のコミュニティを巻き込み、`,
'sb3cbcc1bd0fff140': `プロパティが存在しないことを確認し、コミュニティがそのプロパティが有用であることに同意したら、まずそれを wiki に文書化する必要があります。`,
'sb3d4f79d9d8b71e5': `送信`,
'sb560fa37a7bfb6c2': `この物件に該当する商品は見つかりませんでした。`,
'sb7f72e4c8a2d3357': `フィルター値...`,
'sb8178320160f84ea': `切り抜きを表示`,
'sbad7d2734149470b': `検証`,
'sbb623d6b18d966a0': `Nutrition facts are displayed on the packaging:`,
'sbd6be5cde472f37c': `すべてのご意見にお答えしました！ご協力ありがとうございました！`,
'sbd9a0b2293b3cd3c': `一人前の分量`,
'sbe472dc3c2685985': `対応する値`,
'sc0520e1732a5c568': `Expand image`,
'sc0cc559e7ede852a': `上部のサイズを変更`,
'sc1c08d0cbcc3bd24': `一致しません`,
'sc52696641af72b53': `インストール`,
'sc5575e3107f87874': `画像を左に回転`,
'sc57b630a7a70c61f': `提案された修正`,
'sc681b137e8f604f7': `削除を確認`,
'sc6daf8a31883f8b9': `画像を移動`,
'sc895972c88d38ca5': `フォークソノミープロパティ`,
'sca0c3305aff570b8': str`per specified serving "${0}"`,
'scace072bef961918': `行`,
'scb3b0671d7b7f640': `新しい価値`,
'scb489a1a173ac3f0': `はい`,
'scbab4bd737ba7934': str`group photo donation ${0}`,
'scd21019c3cd618f3': `Slackディスカッションに参加する`,
'scdb6cad0b92721bf': `プロパティが見つかりません。`,
'scf23a05631f93732': `削除を確認`,
'scfed2f270ef6a3aa': `エリアを選択`,
'sd1022bc1ef9204f7': `ズーム可能な画像`,
'sd1077c055cf9ba6b': `製品の成分リストの検証にご協力ください。`,
'sd698d21ddecba56b': `こんにちは！以下の項目にお答えいただくことで、製品情報の改善にご協力いただけます。`,
'sd82bc2decefa621b': `食品業界から独立し、`,
'sdb97e5976482606e': `プロパティがすでに存在するかどうかを確認する`,
'sdbf806fefc584115': `あなたは`,
'sdc673e73b5c13aea': `削除`,
'sdc792b75f1edcaba': `材料のスペルの修正にご協力ください。`,
'sdca5deead576ceee': `右下のサイズを変更`,
'sdcc2555c5dde524f': `このアイテムを削除してもよろしいですか? この操作は元に戻せません。`,
'se206feec7ec57b28': `100gあたり`,
'se419a9ab36987490': `無効化`,
'se5127cf0f92e7e48': `ヒント:`,
'se773f50d2a16d481': `Rotate image to the right`,
'sebb2c6c830a44574': `technical infrastructure (website/mobile app) &amp; a small permanent team`,
'sec6377f3c4e9b28c': `より良い作物を提案します`,
'seea3800e27baa686': `個別製品`,
'sefaba4adc4ec9219': `フォークソノミープロパティ`,
'seffa8ca49175b5f0': `パーソナライズされたプロパティ`,
'sf44a6b3b232c28ea': str`現在の値を ${0}に置き換えます`,
'sf4cd86a2f5ef2588': `製品バーコード`,
'sf57a61152168cc81': `成分検出の修正にご協力ください`,
'sf88b90b8ba23871c': `不明な一致`,
'sf9aee319a006c9b4': `追加`,
'sfacbbe968fa7d773': `プロパティ名:`,
'sfc40ea3d5d5aa6f8': `皆様のご寄付は、当非営利団体の日常的な運営資金となります。`,
'sfe87465d50530725': `対応する値`,
's5f343a43e7ea9f91': `Error`,
'sd947a599045e9e0e': `Failed to check property conflicts. Please try again.`,
's92a0d19a28995530': `Success`,
's371091f240c17a7e': `Property renamed successfully!`,
's4603f58131a777bf': `Failed to rename property. Please try again.`,
's21694d2ab9c0bec5': `Property deleted successfully!`,
'scf78b75273a6b5fe': `Failed to delete property. Please try again.`,
's71ffcb25fc1c5356': `Rename this property`,
's60320a18282b2b33': `Rename`,
's6e2a82009cc3dfc7': `Delete this property`,
's8bccacf0fc176064': `Rename Property`,
's0df37909a355e56f': str`Rename property '${0}' to:`,
'sb550440eeb3f39c5': `New property name:`,
'sbb53591e587764b7': `Enter new property name...`,
's8acd49e96b4ee7d4': `Check Conflicts`,
'sd1cfdf0ef29cb6a5': `Property Rename Conflicts`,
'sf417737adaa5a8c2': str`Renaming '${0}' to '${1}' will affect:`,
's14571d0ac58a8b43': `Products with both properties:`,
'sb0d459e32656033f': `Products with old property only:`,
'sfa3027dde47305fe': `Products with new property only:`,
's9e5b8feb0892646e': `Do you want to proceed with the rename?`,
's97171907a2d1620b': `Proceed with Rename`,
's712d70fdcc3dd42b': `Delete Property`,
'sc11b78f2f3173f75': str`Are you sure you want to delete the property '${0}'?`,
's3b3fe4e829af3e8e': `This action cannot be undone.`,
's091d3d07b5b3076f': `OK`,
's72c9c4e6ab4ca7ae': `Value replaced successfully!`,
'sdd0eacd725bb2b1d': `Failed to replace value. Please try again.`,
'sfe87a7a8bed11acf': `Value deleted successfully!`,
'sccd2745bdd1087f6': `Failed to delete value. Please try again.`,
's88ece9a678e2f106': `Replace Value`,
's3355d65e22e222c9': str`Replace all instances of '${0}' with a new value:`,
's0d426d718d97d14e': `New value:`,
'se80a1ed3dcab7408': `Enter new value...`,
's2a8434b16dc214a3': `Replace`,
's8263352c7a634e7f': `Delete Value`,
'sebe99e3299746177': str`Are you sure you want to delete all instances of the value '${0}'?`,
's4b0b53abbd6af54a': `Replace this value across all products`,
'sb02836b5e3176cfe': `Delete this value from all products`,
    };
  